import { trackFormSubmissionResult } from "../../../utils/analytics"
import { FormValues } from "./types"

export const trackSubmission = (values: FormValues, errorMessage?: string) =>
  trackFormSubmissionResult({
    formName: "Legal disbursements demo form",
    formData: values,
    errorMessage,
  })
